import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgIconHelpFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "silver",
		fillRule: "evenodd",
		d: "M10 18.333c4.602 0 8.333-3.73 8.333-8.333 0-4.602-3.73-8.333-8.333-8.333-4.602 0-8.333 3.73-8.333 8.333 0 4.602 3.73 8.333 8.333 8.333zM10 5C8.158 5 6.667 6.492 6.667 8.333h1.666c0-.916.75-1.666 1.667-1.666s1.667.75 1.667 1.666c0 .733-.483 1.103-1.025 1.518-.69.53-1.475 1.131-1.475 2.649h1.666c0-.913.593-1.43 1.2-1.962.642-.56 1.3-1.136 1.3-2.205C13.333 6.492 11.842 5 10 5zm-.833 8.333V15h1.666v-1.667H9.167z",
		clipRule: "evenodd",
		opacity: .87
	})
});
export default SvgIconHelpFill;
